/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import { Box, PropTypes, SxProps, Theme } from "@mui/material";
import Spinner from "../Spinner";

export interface LoadingIndicatorProps {
    loading?: boolean;
    color?: PropTypes.Color;
    children?: React.ReactNode;
    className?: string;
    fixed?: boolean;
    sx?: SxProps<Theme>;
    centerSpinner?: boolean;
}

export default function LoadingIndicator({
    loading,
    children,
    className,
    fixed,
    sx,
}: LoadingIndicatorProps) {
    if (loading === undefined || loading) {
        return (
            <Box
                sx={[
                    {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexGrow: 1,
                    },
                    !!fixed && {
                        position: "fixed",
                        inset: 0,
                    },
                    ...(!!sx ? (Array.isArray(sx) ? sx : [sx]) : [])
                ]}
                className={className}
            >
                <Spinner />
            </Box>
        );
    }

    return <>{children}</>;
}
